import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "w-full h-full flex flex-col" }
const _hoisted_2 = { class: "flex items-start justify-start p-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "t-16r text-wrh-blue-light" }, /*#__PURE__*/_toDisplayString('sales'), -1)
const _hoisted_4 = { class: "w-full p-6" }
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = { class: "flex items-center justify-start w-full space-x-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "new-message",
  class: "hidden text-sm font-medium text-gray-700"
}, "Message", -1)
const _hoisted_8 = { class: "flex-grow" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  class: "bg-wrh-green-medium hover:bg-wrh-green-dark text-btn-14m text-white uppercase px-6 py-3.75 rounded",
  type: "submit"
}, /*#__PURE__*/_toDisplayString('messages send'), -1)

import { ref } from 'vue';
import BackArrow from '../../../components/icons/BackArrow.vue';
import ConversationMessage from './ConversationMessage.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const currentUserId = '23465io876745';
const title = 'messages';
const conversations = {
  activeConversation: true,
  activeConversationId: '876496234df',
};

const messages = {
  messages: [
    {
      uid: '0273764023492394',
      body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed gravida semper turpis a convallis. Aliquam erat volutpat. Curabitur fringilla elit nisi, ultrices facilisis ante accumsan sed. Aenean ullamcorper, orci sed dictum gravida, ligula mauris rhoncus libero, non placerat est nulla ac urna. Quisque sit amet nulla sit amet nunc feugiat faucibus eu vel elit. Proin a sem ac urna porta elementum in quis ante. Nulla facilisi. Ut non magna eget est aliquam convallis vitae sed mauris. In efficitur est sed leo placerat varius. Sed rhoncus neque ut tortor convallis aliquet. Proin posuere lectus ac ligula ullamcorper, a gravida orci lacinia. Integer fringilla lacinia sem, dapibus lobortis dui vestibulum at. Vestibulum interdum neque vel posuere venenatis. Curabitur vehicula neque et maximus porttitor.',
      from: [{
        type: 'admin',
        value: {},
      }],
      fromDate: {
        uid: '73409273748239',
        displayName: 'Leonard Cooper',
        photoURL: 'https://images.unsplash.com/photo-1593085512500-5d55148d6f0d?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Y2FydG9vbnxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&w=1000&q=80',
      },
      sentAt: 1630858908,
      readBy: [],
    },
  ],
};

const newMessageInput = ref<HTMLInputElement>();
const newMessageBody = ref('');

const submit = async () => {
  console.log('submit message');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(["lg:hidden mr-3", [
          conversations.activeConversation ? 'flex items-center justify-center' : 'hidden',
        ]])
      }, [
        _createVNode(BackArrow, { class: "w-6 h-6 text-wrh-blue-dark mt-1" })
      ], 2),
      _createElementVNode("div", { class: "w-full flex flex-col justify-start items-start" }, [
        _createElementVNode("h3", { class: "t-22m text-wrh-blue-dark" }, _toDisplayString(title)),
        _hoisted_3
      ])
    ]),
    _createVNode(_TransitionGroup, {
      tag: "div",
      name: "top",
      class: "pt-2 flex-grow overflow-y-auto flex flex-col justify-start space-y-4 scrollbar-thin scrollbar-thumb-wrh-gray-dark scrollbar-track-wrh-gray-extralight px-6 pb-12"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.messages, (message) => {
          return (_openBlock(), _createBlock(ConversationMessage, {
            key: message.uid,
            message: message,
            "current-user-id": currentUserId
          }, null, 8, ["message"]))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("form", {
        onSubmit: _withModifiers(submit, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              id: "new-message",
              ref: (_value, _refs) => {
                _refs['newMessageInput'] = _value
                newMessageInput.value = _value
              },
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (newMessageBody.value = $event)),
              type: "text",
              name: "body",
              class: "focus:ring-black focus:border-black block w-full border-1 border-wrh-gray-dark rounded p-3.75 placeholder-wrh-gray-dark t-14r text-black",
              placeholder: "Write a message..."
            }, null, 512), [
              [_vModelText, newMessageBody.value]
            ])
          ]),
          _hoisted_9
        ])
      ], 40, _hoisted_5)
    ])
  ]))
}
}

})